(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/place-bet/place-bet.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/place-bet/place-bet.js');
"use strict";

var _svs$core$config$data;

const {
  useEffect,
  useRef
} = React;
const {
  placeBetNewPaymentFlow,
  placeBetSelfService
} = svs.components.sport.quickplayModal2.placeBet;
const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;

const usePlaceBet = () => {
  const inProgress = useRef(false);
  useEffect(() => () => {
    inProgress.current = false;
  }, []);

  const placeBet = _ref => {
    let {
      productId,
      drawData,
      closeCallback,
      wallet,
      raceData,
      rowPrice,
      isPixMix,
      handleRedirect
    } = _ref;
    if (inProgress.current) {
      return;
    }
    inProgress.current = true;
    const unlockPaymentFlow = () => {
      inProgress.current = false;
    };
    if (isSelfService) {
      placeBetSelfService({
        drawData,
        raceData,
        productId,
        unlockPaymentFlow,
        closeCallback,
        isPixMix
      });
    } else {
      return placeBetNewPaymentFlow({
        productId,
        closeCallback,
        unlockPaymentFlow,
        wallet,
        rowPrice,
        isPixMix,
        handleRedirect
      });
    }
  };
  return {
    placeBet,
    isPlaceBetInProgress: inProgress.current
  };
};
setGlobal('svs.components.sport.quickplayModal2.placeBet.usePlaceBet', usePlaceBet);

 })(window);